import { Guest, GuestStatus, FormType } from "sharedTypes"

const SAMPLE_GUEST_DATA: Guest = {
  id: "sample-guest-1",
  externalId: "ext-123",
  urls: {
    page: "https://d.io/g/ext-123",
    qr: "https://d.io/g/ext-123/qr",
    email: "https://d.io/g/ext-123/email",
    forms: {},
  },
  checkedIn: 0,
  eventGroups: [{
    id: 1,
    icon: null,
    title: "Guest List",
    notifications: [],
  }],
  eventId: "sample-event-1",
  genderUnknownGuests: 0,
  girlGuests: 0,
  guyGuests: 0,
  notifications: [],
  seatingAssignment: {
    guestId: "sample-guest-1",
    id: 1,
    seat: 1,
    seatingTableId: 1,
    seatingTableTitle: "Table/Row",
    shape: "round",
  },
  status: GuestStatus.Confirmed,
  personInfo: {
    id: "sample-person-1",
    averageRating: 0,
    birthDate: "",
    companyName: "Company",
    companyTitle: "Title",
    customFields: [],
    email: "Email",
    emailHardBounced: false,
    emailSoftBounced: false,
    firstName: "First Name",
    gender: "",
    lastName: "Last Name",
    noShows: 0,
    notes: "",
    photoUrl: "",
    totalAttended: 0,
    totalConfirmed: 0,
    totalEvents: 0,
    totalSpent: 0,
    transactions: [],
    unsubscribed: false,
    optedInWhatsapp: false,
    formSubmissionLineItems: [{
      externalId: "sample-li-1",
      createdAt: new Date().toISOString(),
      currency: "USD",
      formType: FormType.Ticket,
      id: "sample-li-1",
      name: "Ticket Name",
      price: "0",
      formSubmission: {
        eventId: "sample-event-1",
        externalId: "sample-fs-1",
        paymentMethod: "",
        paymentDetails: "",
      },
      guestId: "sample-guest-1",
      responses: [],
    }],
    phone: "",
    city: "City",
    country: "US",
    address: {
      line1: "",
      line2: "",
      city: "City",
      zip: "",
      country: "US",
      state: "State",
    },
  },
  waitlistTable: null,
  standing: false,
  group: [],
  questionsAndAnswers: [],
  createdTime: "",
  updatedAt: "",
}

export default SAMPLE_GUEST_DATA

export const sampleGuestFor = (portalUrl?: string): Guest => {
  if (!portalUrl) return SAMPLE_GUEST_DATA

  const page = `${portalUrl.replace(/\/(p|e\/[^/]+)$/, "")}/g/${SAMPLE_GUEST_DATA.externalId}`

  return {
    ...SAMPLE_GUEST_DATA,
    urls: {
      page, qr: `${page}/qr`, email: `${page}/email`, forms: {},
    },
  }
}
